export default function ({
  redirect,
  app
}) {
  if (app.i18n.locale !== 'ru') {
    redirect(`/${app.i18n.locale}`)
  }
}
